import { useApiMutation } from "./use-api-mutation";
import useInvalidateShop from "./use-invalidate-shop";

type UseRemoveTeamInvitationParams = {
	onSuccess?: () => void;
	onError?: () => void;
};

export default function useDeleteTeamInvitation(
	shopId: string,
	email: string,
	options?: UseRemoveTeamInvitationParams,
) {
	return useApiMutation(
		"delete",
		"/shops/{shopId}/members/{email}/invitations",
		{
			invalidate: useInvalidateShop(shopId),
			onSuccess: options?.onSuccess,
			onError: options?.onError,
			mapVariables: async () => ({
				params: { path: { shopId, email } },
			}),
		},
	);
}
